import { PricingText } from 'components/PricingText'

export const CardPricingLine = ({
  hideMoneyBackGuarantee = false, // pen-7562_v1
}: {
  hideMoneyBackGuarantee?: boolean // pen-7562_v1
}) => (
  <PricingText
    translationKey='shortPriceStyled'
    className='d-block mc-text-small'
    hideMoneyBackGuarantee={hideMoneyBackGuarantee}
    promoClassNames={{ copy: 'mc-opacity--hinted' }}
  >
    <span className='mc-opacity--muted' />
    <span className='mc-text--bold' />
  </PricingText>
)
